import {
  Box,
  Checkbox,
  FormHelperText,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Grid,
  InputLabel,
  Chip,
  Button,
  Typography,
  Divider,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import Form from "../../../components/forms/Forms";
import AdminApi from "../../../config/apis/admin";
import { api, matchingApi, resolveUrl } from "../../../config/apis";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import styles from "./style.module.css";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { SERVER_KEY } from "../../../config/constants/EnviormentVariables";
import { IsStudent, downloadFile } from "../../../helper/helperFunction";
import { useAuth } from "../../../hooks/auth/auth";

export default function EditSkills(params) {
  const userIsStudent = IsStudent();
  const { state: authState } = useAuth();
  // Paths are relative to the matching service base URL
  // (REACT_APP_MATCHING_API_BASE) configured on the matchingApi instance.
  const resumeProcessUrl = "resumes/process";
  const resumeUpdatedUrl = "resumes/updated";

  const [formData, setFormData] = useState({
    skills: [],
    job_type: [],
    other_skill_name: [],
    resume: null,
    cover_letter: null,
    cover_letter_title: null,
  });

  const [fileView, setFileView] = useState();
  const [skillLevel, setSkillLevel] = useState([]);
  const [modules, setModules] = useState([]);
  const [succes, setSucces] = useState(false);
  const [jobTypeError, setJobTypeError] = useState("");
  const [otherSkillInput, setOtherSkillInput] = useState("");

  const FechSkillsData = useCallback(async () => {
    const res = await api.get(AdminApi.STUDENT_SKILLS_LIST);
    const ResSkillLevel = await api.get(AdminApi.PROFILE_SKILLS_LEVELS);
    setSkillLevel(ResSkillLevel.data.data ?? []);
    setModules(res.data.data ?? []);
  }, []);

  useEffect(() => {
    FechSkillsData();
  }, [FechSkillsData]);

  useEffect(() => {
    const FechProfileData = async () => {
      try {
        const res = await api.get(AdminApi.PROFILE_VIEW);
        const data = res.data.data || {};

        setFormData({
          skills: data.skills || [],
          job_type: data.job_type || [],
          other_skill_name: data.other_skill_name || [],
          cover_letter_title: data.cover_letter_title || [],
          resume: null,
          cover_letter: null,
        });
        setFileView(data);
      } catch (error) {
        console.error("Error fetching profile data:", error);
      }
    };
    if (!params.id) {
      FechProfileData();
    }
  }, [succes]);

  useEffect(() => {
    const FechProfileData = async () => {
      try {
        const res = await api.get(
          resolveUrl(AdminApi.PROFILE_VIEW_ADMIN, params.id)
        );
        const data = res.data.data || {};

        setFormData({
          skills: data.skills || [],
          job_type: data.job_type || [],
          other_skill_name: data.other_skill_name || [],
          cover_letter_title: data.cover_letter_title || [],
          resume: null,
          cover_letter: null,
        });
        setFileView(data);
      } catch (error) {
        console.error("Error fetching profile data:", error);
      }
    };
    if (params.id) {
      FechProfileData();
    }
  }, [params.id]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => {
      const updatedSkills = [...prevFormData.skills];
      const existingSkillIndex = updatedSkills.findIndex(
        (s) => s.skill_id == name
      );

      if (existingSkillIndex !== -1) {
        updatedSkills[existingSkillIndex] = {
          skill_id: name,
          skill_level_id: value,
        };
      } else {
        updatedSkills.push({ skill_id: name, skill_level_id: value });
      }

      return {
        ...prevFormData,
        skills: updatedSkills,
      };
    });
  };

  const handleJobTypeGroupChange = (event) => {
    setFormData({
      ...formData,
      job_type: [event.target.value],
    });
  };

  const handleJobTypeCheckbox = (item) => {
    setFormData((prevFormData) => {
      const updatedJobTypes = prevFormData.job_type.includes(item)
        ? prevFormData.job_type.filter((selectedItem) => selectedItem !== item)
        : [...prevFormData.job_type, item];

      if (updatedJobTypes.length > 0) {
        setJobTypeError("");
      }

      return {
        ...prevFormData,
        job_type: updatedJobTypes,
      };
    });
  };

  const validateForm = () => {
    if (!formData.job_type || formData.job_type.length === 0) {
      setJobTypeError("Please select at least one job type");
      return false;
    }
    setJobTypeError("");
    return true;
  };
  const commitOtherSkills = (rawValue) => {
    const parts = rawValue
      .split(",")
      .map((skill) => skill.trim())
      .filter((skill) => skill.length > 0);

    if (parts.length === 0) return;

    setFormData((prev) => {
      const existing = prev.other_skill_name || [];
      const merged = [...existing];
      parts.forEach((p) => {
        if (!merged.includes(p)) merged.push(p);
      });
      return { ...prev, other_skill_name: merged };
    });
  };

  const handleOtherSkillChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue.includes(",")) {
      commitOtherSkills(inputValue);
      setOtherSkillInput("");
      return;
    }
    setOtherSkillInput(inputValue);
  };

  const handleOtherSkillKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      commitOtherSkills(otherSkillInput);
      setOtherSkillInput("");
    }
  };

  const handleOtherSkillBlur = () => {
    if (otherSkillInput.trim()) {
      commitOtherSkills(otherSkillInput);
      setOtherSkillInput("");
    }
  };
  const handleChipDelete = (chipIndex) => {
    const updatedArray = [...formData.other_skill_name];
    updatedArray.splice(chipIndex, 1);
    setFormData({
      ...formData,
      other_skill_name: updatedArray,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const { id } = event.target;

    if (!file) return;

    const allowedExtensions = ["pdf", "doc", "docx"];
    const allowedMimeTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    const fileExtension = file.name.split(".").pop().toLowerCase();
    const isAllowed =
      allowedExtensions.includes(fileExtension) &&
      (file.type === "" || allowedMimeTypes.includes(file.type));

    if (!isAllowed) {
      toast.error("Only PDF, DOC, and DOCX files are allowed.");
      event.target.value = "";
      return;
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [id === "resumeInput" ? "resume" : "cover_letter"]: file,
    }));
  };

  const ApiUrl = userIsStudent
    ? AdminApi.PROFILE_SAVE
    : AdminApi.PROFILE_SAVE_FROM_ADMIN;

  const handleDownload = (filePathParam, fileNameParam) => {
    const filePath = filePathParam;
    const fileName = fileNameParam;

    try {
      downloadFile(filePath, fileName);
    } catch (error) {
      console.error("Error during download:", error);
    }
  };

  const UpdatedFormData = {
    ...formData,
    other_skill_name: formData.other_skill_name.filter((skill) => skill) ?? [],
  };

  const handleSaveSuccess = (resData) => {
    // Only students trigger resume processing, and only when a new resume file is selected.
    if (userIsStudent && formData.resume) {
      matchingApi.post(resumeProcessUrl).catch((error) => {
        console.error("Error processing resume:", error);
      });
    }

    // Whenever a student saves (CV or any other profile detail updated),
    // queue an AI resume refresh so matching stays up to date.
    if (userIsStudent) {
      const studentId = authState?.user?.id;

      if (studentId) {
        matchingApi
          .post(resumeUpdatedUrl, {
            student_id: studentId,
            run_async: true,
          })
          .then((res) => {
            if (res?.data?.status === "accepted") {
              toast.info("AI is enhancing your resume for better matching..", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "light",
              });
            }
          })
          .catch((error) => {
            console.error("Error queuing AI resume refresh:", error);
          });
      }
    }

    if (params.setSuccess) {
      params.setSuccess(resData);
    }
  };

  return (
    <>
      <Typography variant="h2" gutterBottom className={styles.heding_2}>
        Skills
      </Typography>
      <Box className="page-container permission_wrap">
        <Form
          submitUrl={ApiUrl}
          formData={UpdatedFormData}
          setFormSuccess={setSucces}
          successPath={
            userIsStudent ? "/admin/setting" : "/admin/student-resume"
          }
          onSuccess={handleSaveSuccess}
          multipart={true}
          editId={params.id}
          validate={validateForm}
        >
          <Box className="permission_table">
            <Table>
              <TableHead>
                <TableRow className="table-head">
                  <TableCell className="table-heading">Skill Name</TableCell>
                  {skillLevel.map((item) => {
                    return (
                      <TableCell className="table-heading" key={item.id}>
                        {item.label}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody className="table-body">
                {modules.map((module) => (
                  <TableRow key={module.id}>
                    <TableCell className="table-cell">{module.skill}</TableCell>
                    <RadioGroup
                      sx={{ display: "contents" }}
                      name={`${module.id}`}
                      value={
                        formData.skills.find(
                          (p) => `${p.skill_id}` == `${module.id}`
                        )?.skill_level_id || "first"
                      }
                      onChange={handleInputChange}
                    >
                      {skillLevel.map((item) => {
                        const radioName = `${item.label}`;
                        return (
                          <TableCell className="table-cell">
                            <FormControlLabel
                              key={radioName}
                              value={item.id}
                              control={<Radio />}
                              // label={item.label}
                            />
                          </TableCell>
                        );
                      })}
                    </RadioGroup>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
          <Grid item xs={12} container sx={{ mb: 3, alignItems: "center" }}>
            <Grid item xs={12} sx={{ mb: 2 }}>
              <InputLabel
                sx={{
                  textAlign: "left",
                  whiteSpace: "normal",
                  lineHeight: "18px",
                }}
              >
                Other Skills (Separate each skill with a comma to add more
                skills.)
              </InputLabel>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                sx={{ maxWidth: "725px" }}
                value={otherSkillInput}
                placeholder="Add comma seprated skill name"
                onChange={handleOtherSkillChange}
                onKeyDown={handleOtherSkillKeyDown}
                onBlur={handleOtherSkillBlur}
              />
              <Box marginTop={2}>
                {formData.other_skill_name.map((skill, index) => (
                  <Chip
                    key={index}
                    label={skill}
                    onDelete={() => handleChipDelete(index)}
                    style={{ margin: 4 }}
                  />
                ))}
              </Box>
            </Grid>
          </Grid>
          <Divider light />

          <Grid
            xs={12}
            container
            justifyContent={"space-between"}
            marginTop={"40px"}
          >
            <Grid item>
              <Typography variant="h5" gutterBottom className={styles.heding_5}>
                My CV
              </Typography>
              <Box className={styles.upload_file_wrap}>
                <Typography variant="body1">
                  {formData.resume && formData.resume.name}
                </Typography>
                <input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                  id="resumeInput"
                />
                <label htmlFor="resumeInput">
                  <Button
                    variant="outlined"
                    component="span"
                    color="primary"
                    className={styles.u_button}
                  >
                    Choose File
                  </Button>
                </label>
              </Box>
              <p className={styles.warningText}>
                File size should not exceed 2.5MB, and only PDF and DOC formats
                are allowed.
              </p>
              <Grid item>
                {fileView && fileView.upload_file && (
                  <a
                    style={{
                      cursor: "pointer",
                      display: "inline-block",
                      marginTop: "20px",
                    }}
                    href={`${SERVER_KEY}/${fileView.upload_file}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Chip
                      className={styles.ChipSet}
                      label={fileView.upload_title}
                      icon={<InsertDriveFileIcon />}
                      sx={{ cursor: "pointer" }}
                    />
                  </a>
                )}
              </Grid>
            </Grid>
            <Grid item>
              <Typography variant="h5" gutterBottom className={styles.heding_5}>
                Upload Cover letter
              </Typography>
              <Box className={styles.upload_file_wrap}>
                <Typography variant="body1">
                  {formData.cover_letter && formData.cover_letter.name}
                </Typography>
                <input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                  id="coverLetterInput"
                />
                <label htmlFor="coverLetterInput">
                  <Button
                    variant="outlined"
                    component="span"
                    color="primary"
                    className={styles.u_button}
                  >
                    Choose File
                  </Button>
                </label>
              </Box>
              <p className={styles.warningText}>
                File size should not exceed 2.5MB, and only PDF and DOC formats
                are allowed.
              </p>
              <Grid item>
                {fileView && fileView.cover_letter_file && (
                  <a
                    style={{
                      cursor: "pointer",
                      display: "inline-block",
                      marginTop: "20px",
                    }}
                    href={`${SERVER_KEY}/${fileView.cover_letter_file}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Chip
                      className={styles.ChipSet}
                      label={fileView.cover_letter_title}
                      icon={<InsertDriveFileIcon />}
                      sx={{ cursor: "pointer" }}
                    />
                  </a>
                )}
              </Grid>
            </Grid>
            <Grid item>
              <Grid item xs={12} sx={{ mb: 2 }}>
                <Typography gutterBottom className={styles.heding_5}>
                  Job Type *
                </Typography>
              </Grid>
              <Grid item>
                <RadioGroup
                  className={styles.radio_label}
                  name="job_type"
                  defaultValue="first"
                  value={formData.job_type}
                  onChange={handleJobTypeGroupChange}
                  sx={{ display: "contents" }}
                >
                  {["Part-time", "Full time", "Home Based"].map(
                    (item, index) => {
                      return (
                        <FormControlLabel
                          key={index}
                          value={item}
                          control={
                            <Checkbox
                              checked={formData.job_type.includes(item)}
                              onChange={() => handleJobTypeCheckbox(item)}
                            />
                          }
                          label={item}
                        />
                      );
                    }
                  )}
                </RadioGroup>
                {jobTypeError && (
                  <FormHelperText error>{jobTypeError}</FormHelperText>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Form>
      </Box>
    </>
  );
}
